import { render } from "./four-stats-pitch.vue?vue&type=template&id=c8a6683a&scoped=true&ts=true"
import script from "./four-stats-pitch.vue?vue&type=script&lang=ts"
export * from "./four-stats-pitch.vue?vue&type=script&lang=ts"

import "./four-stats-pitch.vue?vue&type=style&index=0&id=c8a6683a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a6683a"]])

export default __exports__